export interface ISearchMarket {
  displayName: string
  marketName: string
  exchCode: string
  exchName: string
  exchSlug: string
}

export class SearchMarket implements ISearchMarket {
  constructor(
    public displayName: string = '',
    public marketName: string = '',
    public exchCode: string = '',
    public exchName: string = '',
    public exchSlug: string = ''
  ) {}
}

export default SearchMarket 